
/* tslint:disable */
/* eslint-disable */
/**
 * Profile API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import * as runtime from '../runtime';
import type {FetchOptions} from 'ofetch';
import type {
  FunctionalScopeResource,
  IndustryExpertiseResource,
} from '../models';
import {
    FunctionalScopeResourceFromJSON,
    FunctionalScopeResourceToJSON,
    IndustryExpertiseResourceFromJSON,
    IndustryExpertiseResourceToJSON,
} from '../models';

export interface ListScopesByCategoryRequest {
    jobCategory: string;
}

/**
 * 
 */
export class PublicSkillsAndExpertisesApi extends runtime.BaseAPI {

    /**
     * Gives all industry expertise available
          */
    async listAllExpertiseRaw(initOverrides?: FetchOptions | runtime.InitOverrideFunction): Promise<runtime.FetchResponse<Array<IndustryExpertiseResource>>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request<Array<IndustryExpertiseResource>>({
            path: `/profile/public-api/industry-expertise`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        response._data=response._data?.map(IndustryExpertiseResourceFromJSON);
        return response;
    }

    /**
     * Gives all industry expertise available
          */
    async listAllExpertise(initOverrides?: FetchOptions | runtime.InitOverrideFunction): Promise<Array<IndustryExpertiseResource>> {
        const response = await this.listAllExpertiseRaw(initOverrides);
        return response._data;
    }

    /**
     * Gives all functional scopes available according to the job category
          */
    async listScopesByCategoryRaw(requestParameters: ListScopesByCategoryRequest, initOverrides?: FetchOptions | runtime.InitOverrideFunction): Promise<runtime.FetchResponse<Array<FunctionalScopeResource>>> {
        if (requestParameters['jobCategory'] == null) {
            throw new runtime.RequiredError(
                'jobCategory',
                'Required parameter "jobCategory" was null or undefined when calling listScopesByCategory().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request<Array<FunctionalScopeResource>>({
            path: `/profile/public-api/functional-scopes/{jobCategory}`.replace(`{${"jobCategory"}}`, encodeURIComponent(String(requestParameters['jobCategory']))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        response._data=response._data?.map(FunctionalScopeResourceFromJSON);
        return response;
    }

    /**
     * Gives all functional scopes available according to the job category
          */
    async listScopesByCategory(requestParameters: ListScopesByCategoryRequest, initOverrides?: FetchOptions | runtime.InitOverrideFunction): Promise<Array<FunctionalScopeResource>> {
        const response = await this.listScopesByCategoryRaw(requestParameters, initOverrides);
        return response._data;
    }

}
